export default "__VITE_ASSET__MqnT7sJm__"